import React from 'react';
import { useTranslation } from 'react-i18next';

interface EduBadgeProps {
  eduVerified?: boolean;
  school?: string;
  className?: string;
}

const EduBadge: React.FC<EduBadgeProps> = ({ eduVerified, school, className = '' }) => {
  const { t } = useTranslation();

  if (!eduVerified) {
    return (
      <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600 ${className}`}>
        {t('edu.unverified')}
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-indigo-100 text-indigo-800 ${className}`}>
      🎓 {t('edu.verified')}
      {school ? ` · ${school}` : ''}
    </span>
  );
};

export default EduBadge;
